import React from 'react';
import PropTypes from 'prop-types';

const FragranceFamilyFilter = ({ selected, onChange, className = '' }) => {
  const fragranceFamilies = [
    {
      id: 'all',
      name: 'הכל',
      nameEn: 'All',
      icon: '🌟',
      color: 'from-gray-400 to-gray-500',
      bgColor: 'bg-gray-50',
      borderColor: 'border-gray-200',
      description: 'כל המשפחות'
    },
    {
      id: 'floral',
      name: 'פרחוני',
      nameEn: 'Floral',
      icon: '🌸',
      color: 'from-pink-400 to-rose-500',
      bgColor: 'bg-pink-50',
      borderColor: 'border-pink-200',
      description: 'רומנטי ונשי'
    },
    {
      id: 'fresh',
      name: 'רענן',
      nameEn: 'Fresh',
      icon: '🌿',
      color: 'from-cyan-400 to-blue-500',
      bgColor: 'bg-cyan-50',
      borderColor: 'border-cyan-200',
      description: 'נקי ומרענן'
    },
    {
      id: 'woody',
      name: 'עצי',
      nameEn: 'Woody',
      icon: '🪵',
      color: 'from-amber-600 to-brown-600',
      bgColor: 'bg-amber-50',
      borderColor: 'border-amber-300',
      description: 'חם וארצי'
    },
    {
      id: 'oriental',
      name: 'מזרחי',
      nameEn: 'Oriental',
      icon: '🌹',
      color: 'from-red-500 to-orange-600',
      bgColor: 'bg-red-50',
      borderColor: 'border-red-200',
      description: 'אקזוטי ומתובל'
    },
    {
      id: 'fruity',
      name: 'פירותי',
      nameEn: 'Fruity',
      icon: '🍊',
      color: 'from-yellow-400 to-orange-500',
      bgColor: 'bg-yellow-50',
      borderColor: 'border-yellow-200',
      description: 'מתוק ועליז'
    }
  ];

  return (
    <div className={className}>
      {/* Mobile: Horizontal Scrollable */}
      <div className="lg:hidden">
        <h3 className="text-sm font-semibold text-gray-900 mb-3 px-4">משפחות ריח</h3>
        <div className="flex gap-3 overflow-x-auto pb-4 px-4 scrollbar-hide">
          {fragranceFamilies.map((family) => (
            <button
              key={family.id}
              onClick={() => onChange(family.id === 'all' ? '' : family.nameEn)}
              className={`flex-shrink-0 flex flex-col items-center p-4 rounded-xl border-2 transition-all duration-300 min-w-[100px] ${
                (selected === family.nameEn || (!selected && family.id === 'all'))
                  ? `${family.bgColor} ${family.borderColor} shadow-lg scale-105`
                  : 'bg-white border-gray-200 hover:border-gray-300'
              }`}
            >
              <div className="text-3xl mb-2">{family.icon}</div>
              <div className="text-xs font-semibold text-gray-900 text-center">
                {family.name}
              </div>
            </button>
          ))}
        </div>
      </div>

      {/* Desktop: Grid Cards */}
      <div className="hidden lg:block">
        <h3 className="text-lg font-bold text-gray-900 mb-4 flex items-center gap-2">
          <span className="text-2xl">🌺</span>
          <span>משפחות ריח</span>
        </h3>
        <div className="grid grid-cols-2 gap-3">
          {fragranceFamilies.map((family) => (
            <button
              key={family.id}
              onClick={() => onChange(family.id === 'all' ? '' : family.nameEn)}
              className={`relative overflow-hidden p-4 rounded-xl border-2 transition-all duration-300 text-right group hover:shadow-lg ${
                (selected === family.nameEn || (!selected && family.id === 'all'))
                  ? `${family.bgColor} ${family.borderColor} shadow-lg scale-105`
                  : 'bg-white border-gray-200 hover:border-gray-300'
              }`}
            >
              {/* Background gradient on hover */}
              <div className={`absolute inset-0 bg-gradient-to-br ${family.color} opacity-0 group-hover:opacity-10 transition-opacity duration-300`} />
              
              <div className="relative">
                <div className="flex items-center justify-between mb-2">
                  <div className="text-3xl">{family.icon}</div>
                  {(selected === family.nameEn || (!selected && family.id === 'all')) && (
                    <div className="text-primary-600">
                      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                    </div>
                  )}
                </div>
                <div className="text-sm font-bold text-gray-900 mb-1">
                  {family.name}
                </div>
                <div className="text-xs text-gray-600">
                  {family.description}
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

FragranceFamilyFilter.propTypes = {
  selected: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default FragranceFamilyFilter;

